import React from 'react';
import { initialExploreQuery } from 'routes/Explore/helpers/dummyQuery';
import { ExploreAction } from 'routes/Explore/hooks/reducers/exploreReducer';

type ExploreContextT = {
    explore: ExploreQueryT;
    dispatchExplore: React.Dispatch<ExploreAction>;
};

const ExploreContext = React.createContext<ExploreContextT>({
    explore: initialExploreQuery,
    dispatchExplore: () => {},
});

export const useExploreContext = () => React.useContext(ExploreContext);

export default ExploreContext;
